import React from "react";
import "../Styles/style.css";
import { useLocation } from "react-router-dom";

export default function Specifications() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const make = queryParams.get("mk");
  const model = queryParams.get("md");

  return (
    <>
      <div className="newcar-main">
        <div className="container py-5">
          <h3 className="newcar-infoheading ">
            Key Specifications of {make} {model}
          </h3>

          <div className="my-5" style={{ background: "white" }}>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-6 ">
                <p className="px-3 newcar-specheading">Price</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">32.1 - 37.4 lacs</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Body Type</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">Hatchback</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">
                  Dimensions (Length x Width x Height)
                </p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">3600 x 1475 x 1670 mm</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Ground Clearance</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">170 mm</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">Displacement</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">998 cc</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Transmission</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">Manual & Automatic</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">Horse Power</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">67 hp</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Torque</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">90 Nm</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">Boot Space</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">180 L</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Kerb Weight</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">820 - 835 KG</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">Fuel Type</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">Petrol</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Mileage</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">14 - 18 KM/L</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">Fuel Tank Capacity</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">35 L</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Seating Capacity</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">5 - Persons</p>
              </div>
            </div>
            <div
              className="row pt-3"
              style={{
                borderBottom: "1px solid lightgray",
                margin: 0,
                padding: 0,
              }}
            >
              <div className="col-lg-3 col-md-6">
                <p className="px-3 newcar-specheading">Top Speed</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">180 KM/H</p>
              </div>
              <div className="col-lg-3 col-md-6">
                {" "}
                <p className="px-3 newcar-specheading">Tyre Size</p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 text-end">
                <p className="px-3 newcar-specvalue">145/80/R13</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
